import { useTranslation } from 'react-i18next'
import type { RiskReductionMeasure } from '@/shared/hooks/api/machineryDirectiveCompliance'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/shared/lib/utils'
import {
  getRrmImplementationBadgeKind,
  getRrmImplementationBadgeLabelKey,
  getRrmImplementationBadgeVariant,
} from './rrmImplementationBadgeUtils'

export function RrmImplementationBadge({
  riskReductionMeasure,
  className,
}: {
  riskReductionMeasure: RiskReductionMeasure
  className?: string
}) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const badgeKind = getRrmImplementationBadgeKind(riskReductionMeasure)
  const badgeVariant = getRrmImplementationBadgeVariant(badgeKind)
  const showMutedStyle = badgeKind === 'NOT_IMPLEMENTED'

  return (
    <Badge
      variant={badgeVariant}
      className={cn(
        showMutedStyle && 'font-normal text-muted-foreground',
        className
      )}
    >
      {t(getRrmImplementationBadgeLabelKey(badgeKind))}
    </Badge>
  )
}
